var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("img", { attrs: { src: _vm.dataUrl, alt: "qr", width: _vm.size } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }